import postRobot from 'post-robot'

postRobot.CONFIG.ALLOW_SAME_ORIGIN = true

export default postRobot